import { render, staticRenderFns } from "./mycourseofflinedetail.vue?vue&type=template&id=570c2770&scoped=true&"
import script from "./mycourseofflinedetail.vue?vue&type=script&lang=js&"
export * from "./mycourseofflinedetail.vue?vue&type=script&lang=js&"
import style0 from "./mycourseofflinedetail.vue?vue&type=style&index=0&id=570c2770&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c2770",
  null
  
)

export default component.exports